var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-list-alt" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("tasks")) + "\n    ")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "q-input",
              {
                attrs: {
                  "float-label": _vm.$t("representative"),
                  autocomplete: "new-password",
                  error: _vm.$v.operator.$error,
                  clearable: ""
                },
                on: { input: _vm.$v.operator.$touch, clear: _vm.clearOperator },
                model: {
                  value: _vm.operator_name,
                  callback: function($$v) {
                    _vm.operator_name = $$v
                  },
                  expression: "operator_name"
                }
              },
              [
                _c("q-autocomplete", {
                  attrs: {
                    "min-characters": 3,
                    "value-field": function(v) {
                      return "" + v.label
                    },
                    separator: ""
                  },
                  on: { search: _vm.getOperator, selected: _vm.selectOperator }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("q-datetime", {
              attrs: {
                type: "date",
                "float-label": _vm.$t("task_date"),
                format: "DD/MM/YYYY",
                error: _vm.$v.task_date.$error
              },
              on: { input: _vm.$v.task_date.$touch },
              model: {
                value: _vm.task_date,
                callback: function($$v) {
                  _vm.task_date = $$v
                },
                expression: "task_date"
              }
            })
          ],
          1
        )
      ]),
      _c("q-table", {
        staticClass: "q-my-md",
        attrs: {
          data: _vm.task_steps,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          "row-key": "name",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [0],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "fas fa-plus",
                    label: _vm.$t("new_f")
                  },
                  on: {
                    click: function($event) {
                      return _vm.showAddTask([])
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "id", attrs: { "auto-width": "", props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.id) +
                          "\n            "
                      )
                    ]
                  ),
                  _c("q-td", { key: "branch_name", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.branch_name) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "branch_address", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.branch_address) +
                          "\n            "
                      )
                    ]
                  ),
                  _c("q-td", { key: "collection", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.getCollection(props.row.collection)) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "start_time", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.start_time) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "end_time", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.end_time) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "status",
                      attrs: { props: props, "auto-width": "" }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row.status),
                            color: _vm.getColorStatusList(props.row.status)
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "actions", attrs: { props: props } },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "primary",
                          icon: "fas fa-pencil-alt"
                        },
                        on: {
                          click: function($event) {
                            return _vm.showAddTask(props.row)
                          }
                        }
                      }),
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "negative",
                          icon: "far fa-trash-alt"
                        },
                        on: {
                          click: function($event) {
                            return _vm.confirmRemove(props.row.actions)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-sm" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "fas fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "4traders_tasks" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "positive",
                label: _vm.$t("repeat"),
                icon: "far fa-clock",
                disabled: _vm.disableRecurrence
              },
              on: {
                click: function($event) {
                  return _vm.setRecurrence()
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c("task", {
        attrs: {
          show_task: _vm.show_task,
          task: _vm.task,
          collections: _vm.collections
        },
        on: {
          hide_task: function($event) {
            return _vm.hideTask()
          }
        }
      }),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": "",
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.confirm_recurrence,
            callback: function($$v) {
              _vm.confirm_recurrence = $$v
            },
            expression: "confirm_recurrence"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.confirm_recurrence = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("repeat")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-select", {
                        attrs: { options: _vm.recurring_types },
                        model: {
                          value: _vm.recurring_type,
                          callback: function($$v) {
                            _vm.recurring_type = $$v
                          },
                          expression: "recurring_type"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.recurring_type != "custom"
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c(
                            "q-field",
                            { attrs: { helper: _vm.$t("maximum_of_365") } },
                            [
                              _c("q-input", {
                                attrs: {
                                  type: "number",
                                  prefix: _vm.$t("for"),
                                  suffix: _vm.getInputSufix
                                },
                                model: {
                                  value: _vm.recurring_frequency,
                                  callback: function($$v) {
                                    _vm.recurring_frequency = $$v
                                  },
                                  expression: "recurring_frequency"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.recurring_type == "custom"
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "positive",
                              label: _vm.$t("add_date"),
                              icon: "fas fa-plus"
                            },
                            on: {
                              click: function($event) {
                                return _vm.addDate()
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.recurring_type == "custom"
                    ? _c(
                        "div",
                        { staticClass: "col-12" },
                        _vm._l(_vm.recurring_frequency_custom, function(
                          item,
                          index
                        ) {
                          return _c("q-datetime", {
                            key: index,
                            attrs: {
                              type: "date",
                              clearable: "",
                              format: "DD/MM/YYYY",
                              error: _vm.error_recurring_frequency_custom
                            },
                            on: {
                              clear: function($event) {
                                return _vm.removeDate(index)
                              }
                            },
                            model: {
                              value: item.date,
                              callback: function($$v) {
                                _vm.$set(item, "date", $$v)
                              },
                              expression: "item.date"
                            }
                          })
                        }),
                        1
                      )
                    : _vm._e()
                ]),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-sm" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("cancel")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("cancel"),
                            icon: "fas fa-chevron-left"
                          },
                          on: {
                            click: function($event) {
                              _vm.confirm_recurrence = false
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-3",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "secondary",
                            label: _vm.$t("save"),
                            icon: "far fa-save"
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmRecurrence()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.confirmRecurrence },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_edit_recurring = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "secondary", label: _vm.$t("save") },
                    on: {
                      click: function($event) {
                        return _vm.confirmEditRecurrence()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_edit_recurring,
            callback: function($$v) {
              _vm.confirm_edit_recurring = $$v
            },
            expression: "confirm_edit_recurring"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("edit_recurrence")))
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c(
                "q-field",
                [
                  _c("q-select", {
                    attrs: { options: _vm.types_edit_recurring },
                    model: {
                      value: _vm.type_edit_recurring,
                      callback: function($$v) {
                        _vm.type_edit_recurring = $$v
                      },
                      expression: "type_edit_recurring"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }